export default [
    {
        speakerName: `Joseph Smith`,
        speakerNameRS: `Jožef Kovač`,
        speakerTxt: `I place my hand on her hand.`,
        speakerTxtRS: `Stavio sam svoju ruku preko njene.`,
        dialogFx: `assets/dialog/joseph/joseph0086.mp3`,
        choicesBtns: `unset`,
    },
    {
        speakerTxt: `"Come on, Anna, I am all ears."`,
        speakerTxtRS: `"Slobodno Ana, saslušaću te."`,
        dialogFx: `assets/dialog/joseph/joseph0087.mp3`,
    },
    {
        speakerTxt: `I want to know about her. Everything about her. I want to see her naked imperfections and most horrible mistakes she made in her life. I want to know what aches her heart and what pleases her to the point of ecstasy. I want to know what her favorite color is.`,
        speakerTxtRS: `Želim da znam o njoj. Sve o njoj. Želim da vidim njene gole nesavršenosti i najstrašnije greške koje je napravila u svom životu. Želim da znam za šta je boli srce i šta joj prija do zanosa. Koja joj je omiljena boja.`,
        dialogFx: `assets/dialog/joseph/joseph0088.mp3`,
    },
    {
        speakerName: `Anna Adams`,
        speakerNameRS: `Ana Adamović`,
        speakerTxt: `"My father abandoned us. He married a young and pretty woman. My mother was really in love with him. He abused her since my birth yet she didn't complain. He drank heavily, slept with women and flaunted his money."`,
        speakerTxtRS: `"Otac nas je napustio. Oženio se mladom i lepom ženom. Moja majka ga je baš volela. Zlostavljaoju je od mog rođenja, a ona se nije žalila. Mnogo je pio, spavao sa ženama i razbacivao se novcem."`,
        dialogFx: `assets/dialog/anna/anna0030.mp3`
    },
    {
        characterImg: `assets/chars/anna/cryingCasual.webp`,
        speakerTxt: `"My mother found out about his secret relationship with his secretary. She started having mental breakdowns. Her mental distorted to the point that she is admitted in a mental hospital now."`,
        speakerTxtRS: `"Moja majka je saznala za njegovu tajnu vezu sa sekretaricom. Počela je da ima psihičke slomove. Njen psihičko stanje je oštećeno do te mere da je primljena na duševnu bolnicu."`,
        dialogFx: `assets/dialog/anna/anna0031.mp3`
    },
    {
        speakerName: `Joseph Smith`,
        speakerNameRS: `Jožef Kovač`,
        speakerTxt: `How differently our hearts ache. We don't know what people go through. To me, my mother is the locus of pain. To her, her father.`,
        speakerTxtRS: `Kako drugačije naša srca bole. Ne znamo kroz šta ljudi prolaze. Za mene je moja majka mesto bola. Njoj, njenom ocu.`,
        dialogFx: `assets/dialog/joseph/joseph0089.mp3`,
    },
    {
        speakerName: `Anna Adams`,
        speakerNameRS: `Ana Adamović`,
        speakerTxt: `"Right after their marriage, my step mom disowned us. My mother had no job. I was studying medicine. It was my final year. I had to quit. Couldn't afford to study. So I contacted Millie. Millie is a distant cousin."`,
        speakerTxtRS: `"Odmah nakon njegovog braka, moja maćeha nas se odrekla. Moja majka nije imala posao. Studirala sam medicinu. Bila je to moja poslednja godina. Morala sam da odustanem. Nisam mogla da priuštim studije. Pa sam kontaktirala Milicu. Milica mi je dalja rođaka."`,
        dialogFx: `assets/dialog/anna/anna0032.mp3`
    },
    {
        speakerName: `Joseph Smith`,
        speakerNameRS: `Jožef Kovač`,
        speakerTxt: `"I am really sorry, Anna. If you want to continue with your medical studies, maybe I can help you with that."`,
        speakerTxtRS: `"Žao mi je Ana. Ako želiš da nastaviš sa studijama, možda mogu da ti pomognem."`,
        dialogFx: `assets/dialog/joseph/joseph0090.mp3`,
    },
    {
        characterImg: `assets/chars/anna/closedSmileCasual.webp`,
        speakerTxt: `After a moment, she composed herself.`,
        speakerTxtRS: `Posle trenutka, uspela je da se sredi.`,
        dialogFx: `assets/dialog/joseph/joseph0091.mp3`,
    },
    {
        speakerName: `Anna Adams`,
        speakerNameRS: `Ana Adamović`,
        speakerTxt: `"Thank you, Joseph. I will look into that."`,
        speakerTxtRS: `"Hvala ti, Jožef. Razmotriću to."`,
        dialogFx: `assets/dialog/anna/anna0033.mp3`
    }
]